module.exports = __webpack_public_path__ + "img/collection-weddingRingsCarbon.8edba42.webp";